import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useSondaDocumentos } from './documentos-nav'

export function PorteiraDocumentos({ children }: { children: ReactNode }) {
  const { habilitado, carregando } = useSondaDocumentos()
  if (carregando) return null
  if (!habilitado) return <Navigate to="/" replace />
  return <>{children}</>
}
